import { Article, Heading, PageLoader } from '@/components/atoms';
import { useArticles } from '@/api';
import type { Article as ArticleType } from '@/types';

interface SuggestedArticlesProps {
  searchQuery: string;
  onArticleClick: (article: ArticleType) => void;
}

const truncateContent = (content: string, maxLength = 120): string => {
  if (!content || content.length <= maxLength) return content;
  return content.slice(0, maxLength).trim() + '…';
};

export const SuggestedArticles = ({
  searchQuery,
  onArticleClick,
}: SuggestedArticlesProps) => {
  const { data, isLoading } = useArticles(searchQuery);
  const articles = data?.data ?? [];

  if (isLoading) {
    return (
      <div className="lg:col-span-2">
        <Heading level={2} className="mb-4">
          Suggested articles
        </Heading>
        <PageLoader message="Loading articles..." size="sm" />
      </div>
    );
  }

  if (articles.length === 0) {
    return null;
  }

  return (
    <div className="lg:col-span-2">
      <Heading level={2} className="mb-4">
        Suggested articles
      </Heading>
      <div className="space-y-4">
        {articles.map((article) => (
          <Article
            key={article.id}
            title={article.title}
            description={truncateContent(article.content)}
            onClick={() => onArticleClick(article)}
          />
        ))}
      </div>
    </div>
  );
};
